import React from "react";
import { useLocation } from "react-router-dom";
import useCheckMobileScreen from "../../../hooks/useCheckMobileScreen";
import { useIsDesignV2 } from "../../../hooks/useIsDesignV2";

interface IActionButtons {
  onEdit: () => void;
  onRemove: () => void;
  isFree?: boolean;
  notEditable?: boolean;
  isCombo?: boolean
}

const ActionButtons: React.FC<IActionButtons> = (props) => {
  const location = useLocation();
  const isItMobile = useCheckMobileScreen();
  const isDesignV2 = useIsDesignV2();
  const { onEdit, onRemove, isFree, isCombo,notEditable } = props;
  return (
    <span className="d-flex justify-content-between">
      <button
        type="button"
        className={`btn btn-custom text_underline p-0 f-s14 edit-action-btn ${isDesignV2 ? 'ms-2' : 'ms-3'}`}
        onClick={onEdit}
        disabled={(isFree || isCombo || notEditable) ? true : false}
        // disabled
      >
        {"Edit"}
      </button>
      <button
        type="button"
        className="btn btn-custom text_underline p-0 ms-3 f-s14 remove-action-btn"
        onClick={onRemove}
      >
        {"Remove"}
      </button>
    </span>
  );
};

export default ActionButtons;
